import styled from 'styled-components';

export const ContentForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  background: ${(props) => props.theme.white};
  padding: 1rem;
  border-radius: 8px;
  border: 1px solid var(--Gray-gray-100, #D4D6DB);
  background: var(--Main-white, #FFF);
`;


export const ContentInput = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0rem;
  
  background: transparent;

  i {
    position: absolute;
    right: 8px;
    bottom: 16px;
    cursor: pointer;
    
  }
  label {
    margin: 0;
    font-size: 0.875rem;
    font-weight: 400;
    color: #303F4B;
  }

  input {
    all: unset;
    padding: 0.5rem;
    outline: 1px solid transparent;

    font-weight: 400;
    font-size: 0.875rem;

    color: #9196A1;
    border-bottom: 1px solid #9196A1;
    background: var(--Main-white, #FFF);

    &:focus {
      border-bottom: 3px solid #EC6643;
    }

    &:disabled {
      cursor: not-allowed;
      background: ${(props) => props.theme['white-300']};
    }
  }
`;

export const ValidationPassword = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  flex-wrap: wrap;
`;

interface IPropsInfoValidation {
  error: boolean;
}
export const InfoValidationPassword = styled.li<IPropsInfoValidation>`
  list-style: inside;
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  color: ${(props) => (!props.error ? props.theme.black : props.theme.success)};
  align-items: center;
  font-size: 0.75rem;
  align-items: center;
  text-decoration: ${(props) => props.error && 'line-through'};

  /* ::before {
    content: '*';
    display: flex;
    justify-content: center;
    align-items: center;
  } */

  span {
    width: 0.25rem;
    height: 0.25rem;
    background-color: ${(props) =>
      !props.error ? props.theme['gray-700'] : props.theme.success};
    border-radius: 999px;
  }

  /* svg {
    background: ${(props) =>
    !props.error ? props.theme.error : props.theme.success};
    border-radius: 100%;
    color: ${(props) => props.theme.white};
    font-size: 1.1rem;
    opacity: 0.8;
  } */
`;
